import React, { useState } from 'react';

import { Checkbox } from '@arco-design/web-react';
import { IconDown } from '@arco-design/web-react/icon';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';

export interface CheckExpandableProps {
  /** 收缩/展开的内容 */
  children?: React.ReactNode;
  /** checkbox 右侧的文案区域 */
  label?: React.ReactNode;
  /** 是否选中/是否展开 */
  checked?: boolean;
  /** 是否展开的回调 */
  onChange?: (checked: boolean) => void;
  /** 扩展了 icon 位置的形态 分别是: 选择框 | 折叠 */
  type?: 'checkbox' | 'fold';
  /** 父容器样式 */
  style?: React.CSSProperties;
  /** 展开收缩内容区域样式   */
  contentStyle?: React.CSSProperties;
  /** 始终展示在标题下方、展开内容上方的附加区域（如说明文案） */
  persistentContent?: React.ReactNode;
}

/**
 * 可展开的选择框, 用于展示一些可展开的内容,
 * 不展开就类似于一个 checkbox
 */
export function CheckExpandable({
  children,
  label,
  checked: propsChecked,
  onChange,
  type = 'checkbox',
  style,
  contentStyle,
  persistentContent,
}: CheckExpandableProps) {
  const [internalChecked, setInternalChecked] = useState(false);
  const isControlled = propsChecked !== undefined;
  const checked = isControlled ? propsChecked : internalChecked;

  const handleChange = (value: boolean) => {
    if (!isControlled) {
      setInternalChecked(value);
    }
    if (onChange) {
      onChange(value);
    }
  };
  return (
    <div style={style}>
      <LabelContainer
        onClick={(e) => {
          e.stopPropagation();
          handleChange(!checked);
        }}
      >
        {type === 'checkbox' && (
          <div onClick={(e) => e.stopPropagation()}>
            <StyledCheckbox checked={checked} onChange={(value) => handleChange(value)} />
          </div>
        )}
        {type === 'fold' && (
          <FoldMark $checked={checked}>
            <IconDown />
          </FoldMark>
        )}
        <Label>{label}</Label>
      </LabelContainer>
      {persistentContent}
      <AnimatePresence>
        {checked && (
          <ExpandableContent
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              duration: 0.08,
              ease: 'easeInOut',
            }}
            style={{ ...contentStyle }}
          >
            {children}
          </ExpandableContent>
        )}
      </AnimatePresence>
    </div>
  );
}

/** ============================ 样式 ==================================== */
const StyledCheckbox = styled(Checkbox)``;
const FoldMark = styled.div<{ $checked?: boolean }>`
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  svg {
    transform: rotate(${(props) => (props.$checked ? -180 : 0)}deg);
    transition: transform 0.1s;
  }
`;

const ExpandableContent = styled(motion.div)``;

const LabelContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

const Label = styled.div`
  margin-left: 8px;
`;
